import React, { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import {
  ChallengeDetailsContainer,
  Container,
  CountUsers,
  Footer,
  ImageContainer,
} from './styles';
import IChallengeDataProps from '../../dtos/IChallengeDataProps';
import {
  CrossIcon,
  RoundCheckIcon,
  SpinnerIcon,
  SubmissionIcon,
  UsersIcon2,
} from '../../assets/svg/SVGComponents';
import { useModal } from '../../hooks/modal';

const ChallengeDetailsModal: React.FC<IChallengeDataProps> = ({
  illustration_url,
  title,
  slug,
  description,
  start_submission,
  end_submission,
  count_submissions,
  status,
}) => {
  const { closeModal } = useModal();
  const navigate = useNavigate();

  const handleParticipateClick = useCallback(() => {
    closeModal();
    navigate(`/create/post/challenge/${slug}`);
  }, [closeModal, navigate, slug]);

  const formattedSubmissionTime = useMemo(() => {
    const startDate = new Date(start_submission);
    const endDate = new Date(end_submission);

    // Formata as datas para dd/MM
    const formattedStart = startDate.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
    });

    const formattedEnd = endDate.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
    });

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    const daysRemaining = Math.ceil(
      (endDate.getTime() - today.getTime()) / (1000 * 3600 * 24),
    );

    const statusMessage =
      daysRemaining <= 0
        ? 'encerrado'
        : `faltam ${daysRemaining} dia${daysRemaining !== 1 ? 's' : ' '}`;

    return `Período: ${formattedStart} a ${formattedEnd} • ${statusMessage}`;
  }, [end_submission, start_submission]);

  const buttonProps = useMemo(() => {
    switch (status) {
      case 'no_submit':
        return {
          label: 'Participar',
          icon: <SubmissionIcon width="1rem" strokeWidth={2} stroke="#fff" />,
          bgColor: '#FF9800', // Laranja
        };
      case 'submited':
        return {
          label: 'Participando',
          icon: <SpinnerIcon width="1rem" strokeWidth={2} stroke="#fff" />,
          bgColor: '#FFA726', // Laranja mais claro
        };
      case 'completed':
        return {
          label: 'Concluído',
          icon: <RoundCheckIcon width="1rem" strokeWidth={2} stroke="#fff" />,
          bgColor: '#4CAF50', // Verde
        };
      default:
        return {
          label: 'Participar',
          icon: <SubmissionIcon width="1rem" strokeWidth={2} stroke="#fff" />,
          bgColor: '#FF9800',
        };
    }
  }, [status]);

  return (
    <Container>
      <ImageContainer>
        <img src={illustration_url} alt="default" />
      </ImageContainer>
      <ChallengeDetailsContainer>
        <button type="button">
          <CrossIcon
            onClick={closeModal}
            width="1.22rem"
            stroke="#323232"
            strokeWidth={1.5}
          />
        </button>
        <h1>{title}</h1>
        <p>{description}</p>

        <span>{formattedSubmissionTime}</span>

        <Footer>
          <PrimaryButton
            style={{ backgroundColor: buttonProps.bgColor }}
            onClick={() => handleParticipateClick()}
          >
            {buttonProps.icon}
            {buttonProps.label}
          </PrimaryButton>
          <CountUsers>
            <UsersIcon2 width="1rem" strokeWidth={2} stroke="#1e88e5" />
            {count_submissions}
            {' professores'}
          </CountUsers>
        </Footer>
      </ChallengeDetailsContainer>
    </Container>
  );
};

export default ChallengeDetailsModal;
